import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

const defaultProps = {
  items: 8,
  top: 55,
  spacing: 40
};

const propTypes = {
  top: PropTypes.number,
  items: PropTypes.number,
  spacing: PropTypes.number,
  style: PropTypes.object,
};

export class FormLoader extends React.Component {

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { style = {}, top, spacing } = this.props;
    let rows = [];
    let styles = { ...style };
    if(top) {
      styles.marginTop = top;
    }
    for(let i = 0; i < this.props.items; i += 1) {
      rows.push(<div key={i} className={inputMock} style={{ marginBottom: spacing }} />)
    }

    return (
      <div className={wrapper} style={styles}>
        {rows}
      </div>
    );
  }
}

FormLoader.defaultProps = defaultProps;
FormLoader.propTypes = propTypes;
export default FormLoader;

const wrapper = css`
  overflow: hidden;
  max-height: 100vh;
`;

const inputMock = css`
  background: rgba(206, 206, 206, 0.19);
  border-radius: 4px;
  width: 100%;
  height: 39px;
  border: 1px solid transparent;
  :first-child {
    margin-top: 20px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/loaders/ListLoader.jsx